<template>
  <input-select-filter
    label="Empresa"
    :options="listaEmpresas"
    v-model="comboEmpresaSelecionada"
  />
</template>
<script>
import InputSelectFilter from "../inputs/InputSelectFilter";
export default {
  components: {
    InputSelectFilter,
  },
  computed: {
    listaEmpresas: function () {
      return this.$store.state.app.listaEmpresas;
    },
    comboEmpresaSelecionada: {
      get: function () {
        return this.$store.state.app.selectedCompanyObj
          ? this.$store.state.app.selectedCompanyObj.id
          : "";
      },
      set: function (value) {
        this.$store.commit(
          "app/setSelectedCompany",
          this.listaEmpresas.find((el) => el.value == value)
        );
        this.$emit("update");
      },
    },
  },
};
</script>
<style lang=""></style>
